import { gql } from '@apollo/client/core';

import {
  ORDER_CHECKOUT_CONTEXT_FIELDS,
  ORDER_FIELDS,
  ORDER_LIST_FIELDS,
  ORDER_REFUND_APPROVAL_FIELDS,
} from './order.fragments.graphql';

export const GET_ORDER = gql`
  ${ORDER_FIELDS}

  query GetOrder($id: ID!) {
    order(id: $id) {
      ...OrderFields
    }
  }
`;

/** Блок оплаты в карточке закрытого наряда: статус и суммы по способам, без строк, чеков и аудита. */
export const GET_ORDER_PAYMENT_SUMMARY = gql`
  query GetOrderPaymentSummary($id: ID!) {
    order(id: $id) {
      id
      status
      refunded_amount
      acquiring_instrument
      money_parts {
        id
        method
        amount
      }
    }
  }
`;

export const GET_ORDER_BY_BOOKING_GROUP = gql`
  ${ORDER_FIELDS}

  query GetOrderByBookingGroup($bookingGroupId: ID!) {
    orderByBookingGroup(bookingGroupId: $bookingGroupId) {
      ...OrderFields
    }
  }
`;

export const GET_ORDER_CHECKOUT_CONTEXT = gql`
  ${ORDER_CHECKOUT_CONTEXT_FIELDS}

  query GetOrderCheckoutContext($orderId: ID!) {
    orderCheckoutContext(orderId: $orderId) {
      ...OrderCheckoutContextFields
    }
  }
`;

export const GET_ORDER_REFUND_APPROVALS = gql`
  ${ORDER_REFUND_APPROVAL_FIELDS}

  query GetOrderRefundApprovals($live: Boolean, $first: Int!, $after: String) {
    orderRefundApprovals(live: $live, first: $first, after: $after) {
      edges {
        cursor
        node {
          ...OrderRefundApprovalFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
      }
    }
  }
`;

export const GET_RECENT_LOCATION_ORDERS = gql`
  ${ORDER_LIST_FIELDS}

  query GetRecentLocationOrders($first: Int!, $after: String) {
    recentLocationOrders(first: $first, after: $after) {
      edges {
        cursor
        node {
          ...OrderListFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
      }
    }
  }
`;
